
import { Vue, Component, Prop } from 'vue-property-decorator';
import { t } from '@/utils';
import {MutationType, SiteId} from "@/enums";

import { attemptLoadMockData } from '@/utils/mockData';
import store from "@/store";

attemptLoadMockData();

@Component({})
export default class App extends Vue {
	beforeCreate() {
		Object.defineProperty(Vue.prototype, '$t', {
			value: t
		});

		this.$store.commit(MutationType.INITIALIZE_STORE);


		let endTime: Date = new Date();
		store.commit(MutationType.SET_SESSION_DURATION_START_TIME, endTime);
	}
}

